// @ts-nocheck

import { route } from 'ziggy-js'
import { defineNuxtPlugin } from '#app'

//Hole die generierten Routes aus dem geteilten globalstorage-Ordner
// eslint-disable-next-line import/order
import { Ziggy } from '../../globalstorage/ziggy.js'

//Override Base URL, because we want to use base URL defined in axiosBase.js Plugin
Ziggy.baseUrl = '/'

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('apiRoute', (name: string, params: any, absolute: boolean) => route(name, params, absolute, Ziggy))
})

declare module '#app' {
    interface NuxtApp {
        $apiRoute: (name: string, params?: any, absolute?: boolean) => string;
    }
}